let locale = 'de';

function sortByAlphabet(a, b) {
  if (a.label.localeCompare) {
    return a.label.localeCompare(b.label, locale, { sensitivity: 'base' });
  }

  if (a.label === b.label) {
    return 0;
  }

  return (a.label < b.label) ? -1 : 1;
}

function sortByCount(a, b) {
  if (a.count === b.count) {
    return sortByAlphabet(a, b);
  }

  return (a.count < b.count) ? 1 : -1;
}

function sortByPopularity(a, b) {
  if (a.popularity === b.popularity) {
    return sortByAlphabet(a, b);
  }

  return (a.popularity > b.popularity) ? 1 : -1;
}

function prominentsort_options(items) {
  if (
    this.context
    && this.context.config
    && this.context.config.language
  ) {
    locale = this.context.config.language;
  }

  if (!items || !items.length) {
    return items;
  }

  const itemLength = items.length;
  let topTierItems = [];

  if (
    itemLength >= 20
    && (
      typeof items[0].count === 'number'
      || typeof items[0].popularity !== 'undefined'
    )
  ) {
    items.sort(typeof items[0].popularity !== 'undefined' ? sortByPopularity : sortByCount);

    const topTierCount = Math.min(5, Math.max(3, Math.floor(itemLength * 0.1)));

    topTierItems = items.splice(0, topTierCount);
    topTierItems = topTierItems.map((item) => {
      item.toptier = true;

      return item;
    });
  }

  items.sort(sortByAlphabet);

  return topTierItems.concat(items);
}

module.exports = prominentsort_options;



// WEBPACK FOOTER //
// ./src/libs/twig/prominentsort_options/index.js